import React, { useContext, useEffect, useState } from "react";
import { JSDCContext, JSDCProvider } from "jsdc-dui/dist/JSDC/Context";
import JSDC from "jsdc-dui/dist/JSDC";
import { latLng, latLngBounds } from "leaflet";
import {
  IDuiContextProviderProps,
  DuiContextProvider,
} from "jsdc-dui/dist/components/Context";
import DguideWalksApp from "jsdc-dui/dist/components/DguideWalksApp";
import { DguidewalksProvider } from "jsdc-dui/dist/JSDC/Dguidewalks/Context";
import "jsdc-dui/dist/style/index.css";
import "./index.scss";
import ConfigProvider from "jsdc-dui/dist/JSDC/Dguidewalks/ConfigProvider";
import headerImg from "./assets/key-art_Desktop.png";
import headerImgMb from "./assets/key-art_mobile.jpg";
import aboutImg from "./assets/about.png";
//* fuck
// import Hambarger from "jsdc-dui/dist/components/Icons/Hamburger"

//TODO: EVENT_ID
const EVENT_ID = "n0011";

//TODO: aboutWalkContent
const aboutWalkContent = `跟隨李梅樹的足跡，從三峽山河、淡水港灣、日月潭、太魯閣、蘇澳、臺北城市風景，至日本青森與奧只見湖畔，走出一道橫跨臺灣與日本的藝術之路。李梅樹的畫筆之下，不僅記錄了畫家當時所見的風光，更深蘊著地方文化、人情記憶與藝術家的心靈足跡。`;

const credit = `
<div>
    團隊介紹：國立臺北大學海山學研究中心，聯絡電話(02) 8674 1111＃66903
    <br>
    <br>
    本圖臺是由國立臺北大學海山學研究中心及智紳數位文化事業有限公司共同協力建置：
    <br>
    <br>1. 圖臺內容：王郁品、鍾聿晴、黎子浚文字撰稿；李梅樹紀念館、臺灣大學舊照片資料庫圖版授權；洪健榮、蔡宗穎、林建良、謝基煌、鍾聿晴攝影。
    <br>
    <br>2. 圖臺系統開發：智紳數位文化事業有限公司
    <br>
    <br>除另有聲明外，本網站內容採用創用 CC 姓名標示-非商業性-相同方式分享4.0授權條款授權公眾使用，您可以依授權條款複製、引用、轉載，唯請於合理位置標示本站網址：李梅樹紀念館 https://www.facebook.com/limeishu.org/?locale=zh_TW；海山學研究中心https://haishan.ntpu.edu.tw/index/
</div>	
`;

const duiConfigProps: IDuiContextProviderProps = {
  sidebarTitle: "",
  sidebarSubtitle: "",
  aboutWalkImgSrc: aboutImg,
  aboutWalkContent,
  credit,
  creditHref: "https://www.facebook.com/JRSHENDigitalCulture/",
  headerMBImgSrc: headerImgMb,
  headerDImgSrc: headerImg,
  menuSwitchItems: [{ id: "數位集章", name: "數位集章" }],
  weatherConfig: {
    token: "CWB-232A270E-12F1-4381-B9F2-DF2D2670A077",
    locations: [
      { county: "新北市", town: "淡水區" },
      { county: "新北市", town: "樹林區" },
      { county: "新北市", town: "中和區" },
      { county: "新北市", town: "鶯歌區" },
      { county: "新北市", town: "三峽區" },
      { county: "臺北市", town: "中山區" },
      { county: "臺北市", town: "大同區" },
      { county: "臺北市", town: "文山區" },
      { county: "南投縣", town: "魚池鄉" },
      { county: "宜蘭縣", town: "蘇澳鎮" },
      { county: "花蓮縣", town: "秀林鄉" },
      { county: "澎湖縣", town: "馬公市" },
    ], //TODO: weather 氣象預測地點
  },
  themeConfig: {
    "--dui-primary": "#ec863b", //TODO: theme
    "--dui-accent": "#8353a0", //TODO: 數位集章按鈕顏色
    "--dui-secondary": "#ec863b", //TODO: theme
    "--dui-bg-secondary": "#C9B189", // Dialog background
    "--dui-bg-accent": "#cba17f", //TODO: background
  },
  settingConfig: {
    disabled: true, // 左側選單不出現「工具設定」
    // languageSwitcherDisabled: true, // 或：保留「工具設定」，只藏語言切換器
  },
};
// #e4e7cb
// 景點的 icon、點擊開集章卡片、cluster、集章 key、`?id=` 深連結、
// 列表的定位與導航、底圖、線都由 jsdc-dui 依 Strapi 的資料建立，這裡不需要再處理圖層。
function App() {
  const { Jsdc } = useContext(JSDCContext);

  useEffect(() => {
    (window as any).JSDC = Jsdc;
  }, [Jsdc]);

  return (
    <div className="root">
      <DguideWalksApp
      language="zh-TW"
      // ! 左側數位集章選項
      // mainMenuChildren={
      //   <MenuItemWithDialog
      //     Icon={Checkin}
      //     title="路線顏色"
      //     active={dui.activeMenuId === "數位集章"}
      //     {...dui.menuSwitcherAction("數位集章")}
      //   >
      //     {/* {dui.activeMenuId === "數位集章" && (
      //     <iframe
      //       style={{ height: "100%", border: 0, borderRadius: "5px" }}
      //       src={`https://map.jsdc.com.tw/tools/checkin/${EVENT_ID}/showlist.php?a=${EVENT_ID}`}
      //     ></iframe>
      //   )} */}
      //     {paths.map((path) => (
      //       <div
      //         key={path.name}
      //         style={{
      //           display: "flex",
      //           alignItems: "center",
      //           margin: "20px",
      //         }}
      //       >
      //         <div
      //           style={{
      //             width: "50px",
      //             height: "5px",
      //             backgroundColor: path.color,
      //             alignItems: "center",
      //             marginRight: "10px",
      //           }}
      //         ></div>
      //         <span
      //           style={{
      //             fontSize: "20px",
      //             color: "#000",
      //             // fontWeight: "bold",
      //           }}
      //         >{` ：${path.name}`}</span>
      //       </div>
      //     ))}
      //   </MenuItemWithDialog>
      // }
      />
    </div>
  );
}

const config = new ConfigProvider({ eventId: EVENT_ID });

const AppWrapper: React.FC = () => {
  const [Jsdc] = useState(
    new JSDC(EVENT_ID, {
      bound: latLngBounds(
        //TODO: map view bound
        latLng(42.4128411, 109.2439413),
        latLng(22.8314938, 153.3294536),
      ),
      maxZoom: 20,
    }),
  );

  return (
    <JSDCProvider Jsdc={Jsdc}>
      <DguidewalksProvider
        Jsdc={Jsdc}
        config={config}
      >
        <DuiContextProvider {...duiConfigProps}>
          <App />
        </DuiContextProvider>
      </DguidewalksProvider>
    </JSDCProvider>
  );
};

export default AppWrapper;
